import * as React from 'react'
import { SalesTeamProvider } from './Provider'
import { type IFilterMode, MultiSelectFilter } from '@user/components/Filters'

export function SalesTeamFilter(props: IFilterMode) {
  return (
    <MultiSelectFilter
      {...props}
      hideModeSelect
      name="salesTeamIds"
      label="Sales Team"
      component={SalesTeamProvider}
    />
  )
}
